import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=5a064e92&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=5a064e92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a064e92",
  null
  
)

export default component.exports